import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface SchemaOrgProps {
  type: 'WebSite' | 'BlogPosting' | 'Article' | 'Organization' | 'BreadcrumbList' | 'FAQPage';
  data: Record<string, unknown>;
}

export default function SchemaOrg({ type, data }: SchemaOrgProps) {
  const location = useLocation();
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  useEffect(() => {
    const schemaId = `schema-${type}-${location.pathname}`;
    
    // Remove schema anterior se existir
    const existingSchema = document.getElementById(schemaId);
    if (existingSchema) {
      existingSchema.remove();
    }

    // Cria novo schema
    const script = document.createElement('script');
    script.id = schemaId;
    script.type = 'application/ld+json';
    
    const schemaData = {
      '@context': 'https://schema.org',
      '@type': type,
      ...data,
    };

    script.textContent = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      const schemaToRemove = document.getElementById(schemaId);
      if (schemaToRemove) {
        schemaToRemove.remove();
      }
    };
  }, [type, data, location.pathname, siteUrl]);

  return null;
}
